import "./src/styles/global.css"
import React from "react"
import { recordLanding } from "./src/utils/analytics"

export const onRouteUpdate = () => {
  recordLanding()
}

const ScrollToTop = ({ children, pathname }) => {
  React.useEffect(() => {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    window.scrollTo({ top: 0, left: 0, behavior: "instant" })
  }, [pathname])

  return children
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <ScrollToTop pathname={props.location.pathname}>
      {element}
    </ScrollToTop>
  )
}

export const shouldUpdateScroll = () => {
  return [0, 0]
}
